import * as Types from '../../../__generated__/schema';

import { RuleSummary } from './RuleSummary.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type RuleDetails = Pick<
  Types.Rule,
  | 'body'
  | 'inlineFilters'
  | 'dynamicAlertContext'
  | 'dynamicGroupBy'
  | 'dynamicAlertTitle'
  | 'dynamicSeverities'
> & {
  reports: Array<Pick<Types.DetectionReportMapping, 'key' | 'values'>>;
  tests: Array<
    Pick<Types.DetectionTestDefinition, 'expectedResult' | 'name' | 'resource'> & {
      mocks?: Types.Maybe<
        Array<Pick<Types.DetectionTestMockDefinition, 'objectName' | 'returnValue'>>
      >;
      ruleOutputs?: Types.Maybe<
        Array<Pick<Types.CorrelationRuleTestCaseRuleOutputDefinition, 'id' | 'matches'>>
      >;
    }
  >;
  filterStatement?: Types.Maybe<{
    and?: Types.Maybe<
      Array<{
        condition?: Types.Maybe<
          Pick<
            Types.DetectionFilterCondition,
            'source' | 'target' | 'operator' | 'value' | 'targetTypeHint'
          >
        >;
      }>
    >;
  }>;
} & RuleSummary;

export const RuleDetails = gql`
  fragment RuleDetails on Rule {
    ...RuleSummary
    body
    reports {
      key
      values
    }
    tests {
      expectedResult
      name
      resource
      mocks {
        objectName
        returnValue
      }
      ruleOutputs {
        id
        matches
      }
    }
    filterStatement {
      and {
        condition {
          source
          target
          operator
          value
          targetTypeHint
        }
      }
    }
    inlineFilters
    dynamicAlertContext
    dynamicGroupBy
    dynamicAlertTitle
    dynamicSeverities
  }
  ${RuleSummary}
`;
